import { useCallback } from 'react';

import { attendanceMarkedEvent } from '../../../../../db/classes/pusher-events';
import { usePusherEvent } from '../../../../../pusher';
import { useClassContext } from '../../../Context';
import { addAttendanceMarkedPusherEventDataToClass } from '../helpers';

const useRecordingAttendanceScreen = () => {
  const { setClass } = useClassContext();

  usePusherEvent(
    attendanceMarkedEvent,
    useCallback(
      (event) => {
        const { attendanceTime, attendee, count } = event.payload;

        setClass((prevClass) => {
          return addAttendanceMarkedPusherEventDataToClass(prevClass ?? undefined, {
            attendanceTime,
            attendee,
            count,
          });
        });
      },
      [setClass]
    )
  );
};

export default useRecordingAttendanceScreen;
